(function () {
  function initSection(root) {
    const sliderEl = root.querySelector('[data-categories-swiper]');
    if (!sliderEl) return;

    // Swiper нужен только на десктопе, на <990px используем CSS-grid
    const mql = window.matchMedia('(min-width: 990px)');
    let swiper = null;

    const prevEl = root.querySelector('[data-categories-prev]');
    const nextEl = root.querySelector('[data-categories-next]');

    function enable() {
      if (swiper) return;
      if (typeof Swiper === 'undefined') return;

      const slidesCount = sliderEl.querySelectorAll('.swiper-slide').length;
      swiper = new Swiper(sliderEl, {
        loop: false, // отключаем loop чтобы избежать дублирования слайдов
        spaceBetween: 24, // 2.4rem = 24px как в твоей верстке
        observer: true,
        observeParents: true,
        slidesPerView: 'auto', // ширина берется из CSS
        slidesPerGroup: 1,
        freeMode: false, // отключаем freeMode чтобы слайды не "плавали"
        grabCursor: true,
        touchRatio: 1,
        threshold: 5,
        navigation: {
          nextEl,
          prevEl,
        },
      });
    }

    function disable() {
      if (!swiper) return;
      swiper.destroy(true, true);
      swiper = null;
    }

    function update() {
      if (mql.matches) enable();
      else disable();
    }

    update();
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', update);
    } else if (typeof mql.addListener === 'function') {
      // Safari <14 fallback
      mql.addListener(update);
    }
  }

  function setup() {
    document.querySelectorAll('[data-categories-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

